import { Directive, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';

@Directive({
   selector: '[dom-holder]'
})
export class DomHolderDirective implements OnInit, OnDestroy {
   @Input('dom-holder') private holder:  DomHolder;
  

   constructor(
      public hostRef: ElementRef<HTMLElement>,
   ) { }

   ngOnInit() {
      this.holder.dom = this.hostRef.nativeElement as HTMLElement;
   }

   ngOnDestroy() {
      this.holder.dom = null;
   }
}

export interface DomHolder {
   dom: HTMLElement | null;
}

